import { render, staticRenderFns } from "./DossierCount.vue?vue&type=template&id=e82ade20&scoped=true"
import script from "./DossierCount.vue?vue&type=script&lang=js"
export * from "./DossierCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ade20",
  null
  
)

export default component.exports